import Vue from "vue";
import reddot from "./Reddot";

let reddotList = new Map();
let tempReddot = [];
export default {
  name: "Reddot",
  showDot(target, top = -0.12, left = "noSet", right = "noSet", type = "dot") {
    if (!target) {
      throw new Error("小红点必须有存放容器！ ");
    }
    try {
      let classname = "dot" + Date.now(),
        myTarget =
          target.hasOwnProperty("_isVue") && target._isVue
            ? target.$el
            : Array.isArray(target)
            ? target[0]
            : target; // 兼容组件标签和原生标签
      let tag = target.attributes; // 作为key的值
      if (!reddotList.has(tag)) {
        // 如果当前target没有创建过reddot
        let myDot = new Vue({
          render: (h) =>
            h(reddot, {
              props: {
                top,
                left,
                right,
                // v2.0
                type,
                // v2.0 end
              },
              class: classname,
            }),
        });
        let temp = myDot.$mount();
        myTarget.appendChild(temp.$el); // 挂载到target
        tempReddot.push(tag);
        reddotList.set(tag, myDot);
      }
      reddotList.get(tag).$children[0].show(); // 显示
    } catch (err) {
      console.log(err);
    }
  },
  hideDot(target) {
    if (!target) {
      this.clearReddotList();
    } else {
      let myTarget =
        target.hasOwnProperty("_isVue") && target._isVue
          ? target.$el
          : Array.isArray(target)
          ? target[0]
          : target; // 兼容组件标签和原生标签
      let tag = target.attributes; // 作为key的值

      if (reddotList.has(tag)) {
        reddotList.get(tag).$children[0].hide(); // 隐藏
        reddotList.delete(tag);
      }
    }
  },
  clearReddotList() {
    for (let k of tempReddot) {
      if (reddotList.get(k)) {
        reddotList.get(k).$children[0].hide();
        reddotList.delete(k);
        // 强力清除
        document.querySelectorAll(".dot-box").forEach((i) => i.remove());
        // v2.0
        document.querySelectorAll(".dot-hand").forEach((i) => i.remove());
        document.querySelectorAll(".dot-new").forEach((i) => i.remove());
        // v2.0 end
      }
    }
    // v2.0
    tempReddot = [];
    // v2.0 end
  },
};
